import { Theme } from '@mui/material';

export const communityEventStyles = (theme: Theme, disabled = false) => ({
	root: {
		display: 'flex',
		backgroundColor: '#2E2E2E80',
		position: 'relative',
		width: '100%',
		height: { xs: '464px', sm: '175px' },
		borderRadius: '8px',
		border: '1px solid #FFFFFF1A',
		flexDirection: { xs: 'column', sm: 'row' },
		overflow: 'hidden',
		cursor: disabled ? 'default' : 'pointer',

		"&:hover": {
			borderColor: disabled ? '#FFFFFF1A' : '#FFFFFFCC',
		}
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	},
	avatar: {
		width: { xs: '100%', sm: '132px' },
		height: { xs: '361px', sm: '100%' },
	},
	data: {
		px: '24px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		flex: 1,
		overflow: 'hidden',
	},
	name: {
		width: '100%',
		fontFamily: 'Integral CF',
		fontSize: { xs: '22px', sm: '24px' },
		fontWeight: 400,
		lineHeight: { xs: '28px', sm: '31px' },
		color: '#FFFFFF',
		maxWidth: '100%',
		mb: { xs: 0, sm: '16px' },
		p: { xs: '14px 16px', sm: 0 },
		position: { xs: 'absolute', sm: 'relative' },
		bottom: { xs: '102px', sm: 0 },
		left: 0,
	},
	price: {
		position: 'absolute',
		top: { xs: '8px', sm: '16px' },
		right: { xs: 'auto', sm: '29px' },
		left: { xs: '8px', sm: 'auto' },
		textAlign: 'center',
		minWidth: '45px',
		height: '18px',
		borderRadius: '2px',
		fontFamily: 'Integral CF',
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '15px',
		backgroundColor: '#FFE23F',
		color: '#000000',
		p: '0 6px',
	},
	item: {
		display: 'flex',
		color: '#FFFFFF',
		gap: '7px',
		alignItems: 'center',
		width: '100%',
		overflow: 'hidden',

		"& >svg": {
			width: '24px',
			height: '24px',
		}
	},
	itemText: {
		flex: 1,
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 600,
		lineHeight: '18px',
	},
});
